// eslint-disable-next-line import/prefer-default-export
export function downloadBlobAsFile(data) {
    const fileName = data.headers['content-disposition'].match(/filename=(.+)/)[1].trim();
    const url = window.URL.createObjectURL(data.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
}